module.exports = __webpack_public_path__ + "75f142c83e19be53056d27d3c3da174b.png";